import { gql } from '@grandvisionhq/graphql';
import { sunglassesProductFragment } from '../fragments/sunglasses-product.js';

const GET_PRODUCTS_BY_SKUS = gql`
  query GetProductsBySKUs($skus: [String!]!) {
    getProductsBySKUs(skus: $skus) {
      ... on SunglassesProduct {
        ...SunglassesProductFragment
      }
    }
  }
  ${sunglassesProductFragment}
`;

export { GET_PRODUCTS_BY_SKUS };
//# sourceMappingURL=get-products-by-skus.js.map
